import * as Yup from 'yup';

import { InitialDateStepFormValuesType } from './InitialDateStep.types';

export const InitialDateStepFormSchema = Yup.object().shape<
  InitialDateStepFormValuesType
>({
  statementDate: Yup.string().nullable().required('Please select start date'),
});
